var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-card-wrapper",
    [
      _c(
        "page-card",
        [
          _vm.errorMessage
            ? _c("div", { staticClass: "error-msg" }, [
                _c("span", [_vm._v(_vm._s(_vm.errorMessage))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("page-title", [
            _vm._v("Welcome to ReadTheory!"),
            _c("br"),
            _vm._v("Let's get started!"),
          ]),
          _vm._v(" "),
          _c("page-subtitle", [_vm._v("Signup as a...")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "role-buttons-group" },
            [
              _c("Role-Button", {
                attrs: {
                  src: "/assets/app/signup/icon-student-role.svg",
                  onClick: _vm.onClick,
                  role: "Student",
                },
              }),
              _vm._v(" "),
              _c("Role-Button", {
                attrs: {
                  src: "/assets/app/signup/icon-teacher-role.svg",
                  onClick: _vm.onClick,
                  role: "Teacher",
                },
              }),
              _vm._v(" "),
              _c("Role-Button", {
                attrs: {
                  src: "/assets/app/signup/icon-parent-role.svg",
                  onClick: _vm.onClick,
                  role: "Parent",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }